import { getJWTTokens } from '@shared/libs/local-storage';
import { buildPrivateApiPath } from '@shared/api/api-url';
import axios from 'axios';

interface IExportAllParticipants {
  event_id?: number;
  sent?: boolean;
  typeSent?: string;
  checked?: boolean;
}

export const exportAllParticipants = async (params: IExportAllParticipants): Promise<void> => {
  try {
    const { accessToken } = getJWTTokens();

    const response = await axios.get(buildPrivateApiPath('/api/v1/event_data'), {
      params,
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Участники.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw new Error('Ошибка при экспорте участников');
  }
};
